import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App.tsx';
import { Env } from './lib/env.ts';

const root = ReactDOM.createRoot(document.getElementById('root')!);

// Setup MSW mock server
if (import.meta.env.VITE_API_MOCK === 'true') {
  // Certify MSW's Service Worker is available before start React app.
  import('./api/mock/browser.ts')
    .then(({ worker }) => {
      worker.start({
        onUnhandledRequest(req, print) {
          if (!req.url.includes(Env.API_URL)) {
            return;
          }

          print.warning();
        },
      });
    }) // Run <App /> when Service Worker is ready to intercept requests.
    .then(() => {
      root.render(
        <React.StrictMode>
          <App />
        </React.StrictMode>,
      );
    });
  // Never setup MSW mock server in production
} else {
  root.render(<App />);
}
